import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "recent-appointments-card trezo-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "trezo-card-header d-sm-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "trezo-card-subtitle" }
const _hoisted_4 = { class: "trezo-card-header-menu position-relative" }
const _hoisted_5 = { class: "menu-btn bg-gray border-0 transition d-inline-block bg-transparent border-radius" }
const _hoisted_6 = { class: "d-block position-relative" }
const _hoisted_7 = { class: "trezo-card-content" }
const _hoisted_8 = { class: "row align-items-center" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "calendar" }
const _hoisted_11 = { class: "header d-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "fw-medium text-black" }
const _hoisted_13 = { class: "weekdays text-center" }
const _hoisted_14 = { class: "days text-center" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "blank-day"
}
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "appointments-list position-relative scrollbar" }
const _hoisted_19 = { class: "icon" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "d-flex justify-content-between" }
const _hoisted_22 = { class: "info" }
const _hoisted_23 = { class: "d-block text-black fw-medium" }
const _hoisted_24 = { class: "title d-block text-primary fw-semibold" }
const _hoisted_25 = { class: "status" }
const _hoisted_26 = { class: "user-info d-sm-flex d-lg-block d-xxl-flex justify-content-between" }
const _hoisted_27 = { class: "user d-flex align-items-center" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "d-block text-black fw-semibold" }
const _hoisted_30 = { class: "user d-flex align-items-center" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "d-block text-black fw-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Recent Appointments")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formattedDate), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousMonth && _ctx.previousMonth(...args))),
                class: "p-0 border-0 d-flex align-items-center justify-content-center rounded-circle transition"
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "material-symbols-outlined" }, "chevron_left", -1)
              ]))]),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.monthNames[_ctx.currentMonth]) + " " + _toDisplayString(_ctx.currentYear), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args))),
                class: "p-0 border-0 d-flex align-items-center justify-content-center rounded-circle transition"
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "material-symbols-outlined" }, "chevron_right", -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (day) => {
                return (_openBlock(), _createElementBlock("div", { key: day }, _toDisplayString(day), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysInMonth, (day, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["card border-0 mx-auto text-black fw-medium border-radius", { 'current-day': day.isToday }])
                }, [
                  (day.day !== null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(day.day), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, " "))
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointments, (appointment, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "appointment-item card border-0 position-relative border-radius"
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("img", {
                    src: 
                    appointment.status === 'Done'
                      ? require('@/assets/images/icons/done.svg')
                      : require('@/assets/images/icons/not-done.svg')
                  ,
                    alt: "status"
                  }, null, 8, _hoisted_20)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(appointment.time), 1),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(appointment.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`trezo-badge ${appointment.status.toLowerCase()}`)
                    }, _toDisplayString(appointment.status), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("img", {
                      src: appointment.client.image,
                      class: "rounded-circle",
                      alt: "user-image"
                    }, null, 8, _hoisted_28),
                    _createElementVNode("div", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "d-block text-xs" }, "Client", -1)),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(appointment.client.name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("img", {
                      src: appointment.servedBy.image,
                      class: "rounded-circle",
                      alt: "user-image"
                    }, null, 8, _hoisted_31),
                    _createElementVNode("div", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "d-block text-xs" }, "Served by", -1)),
                      _createElementVNode("span", _hoisted_32, _toDisplayString(appointment.servedBy.name), 1)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}